import store from '@/store'
import config from '@/config'

export default {
  mixins: [
  ],
  computed: {
    liveEvents () {
      var liveEvents = store.getters['livebettingState/liveEvents']
      return liveEvents && liveEvents.filter(ev => !ev.isawaitingstart)
    },
    liveEventsLoaded () {
      return store.getters['livebettingState/liveEventsLoaded']
    },
    boNavigation () {
      return store.getters['bonavigationState/boNavigation']
    },

    idfwbonavigation1 () {
      return this.$route.params.idfwbonavigation1
    },
    idfwbonavigation2 () {
      return this.$route.params.idfwbonavigation2
    },

    dateFormats () {
      return config.app.dateFormats
    },
    isDebug () {
      return this.$route.query.debug || store.getters['getDebugLevel']
    }
  },

  methods: {
    goToEvent (event) {
      if (event.idfoevent) {
        this.$router.push({ name: 'event', params: { idfoevent: event.idfoevent } })
        window.scrollTo(0, 0)
      }
    },
    checkIsNodeNavigationType (node, navigationType) {
      if (node && node.idfwbonavigationtypes) {
        return node.idfwbonavigationtypes.filter(item => item === navigationType).length > 0
      }

      return false
    },
    isDateToday (date) {
      if (date.indexOf('T') === -1) {
        date = date + 'T00:00:00'
      }
      const today = new Date()
      return new Date(date).getDate() === today.getDate() && new Date(date).getMonth() === today.getMonth() && new Date(date).getFullYear() === today.getFullYear()
    },
    isDateTomorrow (date) {
      const day = new Date()
      const nextDay = new Date(day)
      nextDay.setDate(day.getDate() + 1)
      if (date.indexOf('T') === -1) {
        date = date + 'T00:00:00'
      }
      return ((new Date(date)).getDate() === nextDay.getDate()) && (new Date(date)).getMonth() === nextDay.getMonth() && (new Date(date)).getFullYear() === nextDay.getFullYear()
    },
    isLiveEvent (idfoevent) {
      return this.liveEvents.filter(ev => ev.idfoevent === idfoevent).length > 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/BettingOffer.js